var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "try-rocketchart" }, [
    _c("div", { staticClass: "try-rocketchart__wrapper" }, [
      _c(
        "section",
        { staticClass: "left-panel" },
        [
          _c(
            "div",
            {
              staticClass:
                "typographies-display-brand-large left-panel__title secondary-blue"
            },
            [
              _vm._v(
                "\n                " +
                  _vm._s(
                    _vm.$l10n.__(
                      "Anticipez enfin votre trésorerie en toute simplicité !"
                    )
                  ) +
                  "\n            "
              )
            ]
          ),
          _vm._v(" "),
          _c("ImgSvg", { staticClass: "underline" }, [_c("Underline")], 1),
          _vm._v(" "),
          _c(
            "ul",
            { staticClass: "left-panel__content" },
            _vm._l(_vm.content, function(item, index) {
              return _c("li", { key: index, staticClass: "left-panel__item" }, [
                _c(
                  "span",
                  { staticClass: "typographies-paragraph-large-semibold" },
                  [
                    _vm._v(
                      "\n                        " +
                        _vm._s(item.main) +
                        "\n                    "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "span",
                  { staticClass: "typographies-paragraph-large-regular" },
                  [
                    _vm._v(
                      "\n                        " +
                        _vm._s(item.second) +
                        "\n                    "
                    )
                  ]
                )
              ])
            }),
            0
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "left-panel__links flex-row" },
            [
              _c(
                "CompassTooltip",
                {
                  attrs: {
                    disabled: !_vm.tryRocketchartIsDisabled,
                    placement: "bottom-start"
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "content",
                      fn: function() {
                        return [
                          _c("span", {
                            domProps: { innerHTML: _vm._s(_vm.tooltipContent) }
                          })
                        ]
                      },
                      proxy: true
                    }
                  ])
                },
                [
                  _vm._v(" "),
                  _c("CompassButton", {
                    ref: "ButtonConfirm",
                    staticClass: "link-btns__button-confirm",
                    attrs: {
                      label: _vm.$t.__("cashflow.TryRocketchart.try_for_free"),
                      type: "primary",
                      size: "large",
                      disabled: _vm.tryRocketchartIsDisabled
                    },
                    on: {
                      click: function($event) {
                        return _vm.tryRocketchart()
                      }
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("CompassButton", {
                ref: "ButtonContact",
                staticClass: "link-btns__button-contact",
                attrs: {
                  label: _vm.$t.__("common.actions.ask_demo"),
                  size: "large",
                  type: "secondary"
                },
                on: {
                  click: function($event) {
                    return _vm.toRocketchart(true)
                  }
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm._m(0)
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { staticClass: "right-panel" }, [
      _c("img", {
        attrs: {
          src:
            "/ressources/logged/img/cashflow/sellsy-rocketchart-integration.svg"
        }
      })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }